import { addIntersectionItem } from '../util'

export function LazyLoad(context = document) {
    const imageEls = context.querySelectorAll('img.lazy')
    const images = Array.from(imageEls)

    images.forEach(img => {
        addIntersectionItem(img, loadImage)
    })

    const videoEls = context.querySelectorAll('video.lazy')
    const videos = Array.from(videoEls)

    videos.forEach(video => {
        addIntersectionItem(video, loadVideo)
    })
}

function loadImage({ el }, entry) {
    if (!el.classList.contains('lazy') || !entry.isIntersecting) {
        return
    }

    el.classList.remove('lazy')
    el.src = el.dataset.src
}

function loadVideo({ el }, entry) {
    if (!el.classList.contains('lazy') || !entry.isIntersecting) {
        return
    }

    el.classList.remove('lazy')

    if (el.dataset.src) {
        el.src = el.dataset.src
    } else {
        const dataSrcEls = el.querySelectorAll('[data-src]')
        const dataSrcArray = Array.from(dataSrcEls)
        dataSrcArray.forEach(el => {
            el.src = el.dataset.src
        })
    }
}
